export default __webpack_public_path__ + "static/media/fileImport.6876ce61.svg";